<template>
  <div v-if="visible" class="wf-select-user">
    <el-tabs v-model="tabActive" @tab-click="tabClick" :stretch="true">
      <el-tab-pane v-for="item in options" :key="item.id" :label="item.name" :name="item.id"></el-tab-pane>
    </el-tabs>

    <div class="tab-content">
      <!-- 科室负责人 -->
      <template v-if="tabActive == '0'">
        <el-input v-model="keyWord" suffix-icon="el-icon-search" @change="inputChange"
          placeholder="输入编号/关键字搜索科室"></el-input>
        <div class="select-dialog">
          <div class="left-div width100">
            <el-tree :data="STATIC_DeptTrees" ref="my_tree" :props="defaultProps" show-checkbox check-strictly
              @check-change="handleNodeClick" accordion node-key="id" :render-content="renderContent"
              :default-checked-keys="defaultCheckedKeys"></el-tree>
          </div>
        </div>
      </template>
      <!-- 成员 -->
      <template v-if="tabActive == '1'">
        <el-input v-model="query.keyWord" suffix-icon="el-icon-search" @change="inputChange"
          placeholder="输入工号/姓名/部门搜索成员"></el-input>

        <div class="select-dialog">
          <div class="left-div border1-right width50">
            <el-tree :data="STATIC_DeptTrees" :props="defaultProps" @node-click="handleNodeClick" accordion
              node-key="id" :render-content="renderContent"></el-tree>
          </div>
          <div class="right-div">
            <el-checkbox-group v-model="userIdChecked" @change="change">
              <el-checkbox v-for="user in userList" :label="user.id" :key="user.id" style="display: block">{{ user.no +
                ' ' + user.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </template>
      <!-- 智能人员控件 -->
      <template v-if="tabActive == '2'">
        <el-checkbox-group v-model="tableControlChecked" @change="controlChange">
          <el-checkbox v-for="item in attrList" :label="item.key" :key="item.key" style="display: block">{{ item.name
            }}</el-checkbox>
        </el-checkbox-group>
      </template>
      <template v-if="tabActive == '3'" class="box">
        <div class="headBox">
          <el-radio v-model="head" label="1">科室负责人</el-radio>
          <!-- <el-checkbox-group v-model="head">
            <el-checkbox style="display: block">科室负责人</el-checkbox>
          </el-checkbox-group> -->
          <div v-if="head==1">
            <span style="font-size:14px; font-weight: 600; color: #606266;">对应科室字段：</span>
            <el-select  v-model="tableControlCode" @change="headChange" placeholder="请选择">
              <el-option v-for="item in approveDeptList" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="headBox">
          <el-radio v-model="head" label="2">库房协管员</el-radio>
          <!-- <el-checkbox-group v-model="head1">
            <el-checkbox style="display: block">库房管理人员</el-checkbox>
          </el-checkbox-group> -->
          <div v-if="head==2">
            <span style="font-size:14px; font-weight: 600; color: #606266;">对应库房字段：</span>
            <el-select  v-model="tableControlCode1" @change="headChange2" placeholder="请选择">
              <el-option v-for="item in warehouse2Management" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
          </div>
        </div>
      <div class="headBox">
          <el-radio v-model="head" label="3">盘点仓库管理员</el-radio>
           <div v-if="head==3">
              <span style="font-size:14px; font-weight: 600; color: #606266;">对应库房字段：</span>
            <el-select  v-model="tableControlCode2" @change="headChange1" placeholder="请选择">
              <el-option v-for="item in warehouseManagement" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select>
           </div>
           
          <!-- <el-checkbox-group v-model="head1">
            <el-checkbox style="display: block">库房管理人员</el-checkbox>
          </el-checkbox-group> -->
      
        </div>
   
      </template>
    </div>

    <div class="selected-div">
      <template v-for="item in selectVal">
        <div :key="item.id" class="value">
          <span>{{ item.no ? item.no + " " : "" }}{{ item.name + ' ' }}
            <i class="el-icon-close" style="cursor: pointer;" v-preventReClick @click="removeItem(item)" />
          </span>
        </div>
      </template>
    </div>

    <div slot="footer" class="dialog-footer" style="position:absolute;bottom:10px;right:10px">
      <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
    </div>
  </div>
</template>


<script>
// import '../assets/modal.css';
import GetDataMixin from "@/mixin/getData-mixin";
import {
  GetUserList,
  GetApproveDeptKeys,
  GetApproveWarehouseKeys,
  CASLGetApproveDeptKeys,
  CASLGetApproveWarehouseKeys,
  GetApprove2WarehouseKeys
} from '@/api'

export default {
  mixins: [GetDataMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    oldData: {
      type: Array,
      default () {
        return []
      }
    },
    node: {
      type: Object,
      default () {
        return {}
      }
    },
    attrList: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      options: [
        {
          id: '0',
          name: '科室负责人'
        },
        {
          id: '1',
          name: '成员'
        },
        {
          id: '2',
          name: '智能人员控件'
        },
        {
          id: '3',
          name: '高级组件'
        }
      ],
      tabActive: '0',
      selectVal: [],
      keyWord: '',

      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultCheckedKeys: [],
      userList: [],
      userIdChecked: [],
      query: {
        pageIndex: 1,
        pageSize: 100,
        keyWord: '',
        deptId: ''
      },

      // tableControlList: [],   // 控件列表
      tableControlChecked: [],
      warehouseManagement:[],
      warehouse2Management:[],
      head:false, // 选中的控件
      approveDeptList:[],

      tableControlCode:'',
      tableControlCode1:'',
       tableControlCode2:'',
    };
  },
  methods: {
    tabClick (tab) {
      this.selectVal = []
      this.defaultCheckedKeys = []
      this.tableControlCode1= ''
      this.tableControlCode2= ''
      // this.$nextTick(() => {
      //   this.$refs['my_tree'].setCheckedKeys(this.defaultCheckedKeys)
      // })
      this.userIdChecked = []
      this.tableControlChecked = []

      if (this.tabActive == '0') {
        this.getDeptTrees('')
      }
      if (this.tabActive == '1') {
        this.getDeptTrees('')
        // this.getUserList()
      }
    },
    cancel () {
      this.$emit("close");
    },
    submit () {
      if(this.head==2){
        this.tabActive = 5
      }
       if(this.head==3){
        this.tabActive = 4
      }
      if(this.head==1){
        this.tabActive = 3
      }
      console.log(this.selectVal,this.tabActive);
      
      this.$emit("submit", this.tabActive, this.selectVal);
    },

    // inputChange () {

    // },
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node" style="overflow:hidden;font-size:14px">
          <span>{data.no + ' ' + data.name}</span>
        </span>
      );
    },
    handleNodeClick (node, state) {
      if (this.tabActive == '0') {
        if (state) {
          this.selectVal.push(node)
        }
        else {
          this.selectVal = this.selectVal.filter(i => i.id != node.id)
        }
      }
      else if (this.tabActive == '1') {
        this.query.deptId = node.id
        this.getUserList()
      }
    },


    inputChange () {
      // this.$emit('filterMethod', val);
      if (this.query.keyWord) {
        this.STATIC_DeptTrees = []
        this.query.deptId = ''
        this.getUserList()
      }
      else {
        this.getDeptTrees();
        this.userList = []
      }
    },
    getUserList () {
      this.query.state = 1
      GetUserList(this.query).then(res => {
        this.userList = res.returnData.data
      })
    },
    headChange(val){
      let arr = this.approveDeptList.filter(res=>res.key == val)
      this.selectVal = []
      this.selectVal.push(arr[0])
    },
    headChange1(val){
      let arr = this.warehouseManagement.filter(res=>res.key == val)
      this.selectVal = []
      this.selectVal.push(arr[0])
    },
    headChange2(val){
      let arr = this.warehouse2Management.filter(res=>res.key == val)
      this.selectVal = []
      this.selectVal.push(arr[0])
    },
    change (val) {
      if (val && val.length > 0) {
        let isAdd = false
        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.selectVal.find(e => e.id == val[i])
          if (item == null) {
            isAdd = true;
            let obj = this.userList.find(e => e.id == val[i])
            if (obj) {
              this.selectVal.push(obj)
            }
            break;
          }
        }
        // 删除
        if (!isAdd) {
          this.selectVal = this.selectVal.filter(i => val.indexOf(i.id) != -1);
        }
      }
      else {
        this.selectVal = []
      }
    },
    getCASLGetApproveDeptKeys(){
      
      CASLGetApproveDeptKeys({moduleId:this.$route.query.moduleId}).then(res=>{
       this.approveDeptList = res.returnData
      })
    },
    getGetApproveDeptKeys(){
      GetApproveDeptKeys({moduleId:this.$route.query.moduleId}).then(res=>{
       this.approveDeptList = res.returnData
      })
    },
    getCASLGetApproveWarehouseKeys(){
      CASLGetApproveWarehouseKeys({moduleId:this.$route.query.moduleId}).then(res=>{
       this.warehouseManagement = res.returnData
      })
    },
    getGetApproveWarehouseKeys(){
      GetApproveWarehouseKeys({moduleId:this.$route.query.moduleId}).then(res=>{
       this.warehouseManagement = res.returnData
      })
    },
    getGetApprove2WarehouseKeys(){
      GetApprove2WarehouseKeys({moduleId:this.$route.query.moduleId}).then(res=>{
       this.warehouse2Management = res.returnData
      })
    },
    
    controlChange (val) {
      if (val && val.length > 0) {
        let isAdd = false

        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          let item = this.selectVal.find(e => e.key == val[i])
          if (item == null) {
            isAdd = true;
            let obj = this.attrList.find(e => e.key == val[i])
            if (obj) {
              this.selectVal.push(obj)
            }
            break;
          }
        }

        // 删除
        if (!isAdd) {
          this.selectVal = this.selectVal.filter(i => val.indexOf(i.key) != -1);
        }
      }
      else {
        this.selectVal = []
      }
    },


    removeItem (data) {
      this.selectVal = this.selectVal.filter(i => i.id != data.id)
      // this.userChecked = this.userChecked.filter(i => i.id != data.id)
      this.userIdChecked = this.selectVal.map(i => i.id)
    },
  },
  created(){
    
    if(this.$route.query.isMedicine=='true'){
      this.getCASLGetApproveWarehouseKeys()
      this.getCASLGetApproveDeptKeys()
    }else{
      this.getGetApproveWarehouseKeys()
      this.getGetApprove2WarehouseKeys()
      this.getGetApproveDeptKeys()
    }

  },
  watch: {
    'visible' (val, oldVal) {
      // this.selectVal = JSON.parse(JSON.stringify(this.oldData))


      if (val) {
        this.getDeptTrees('')
        this.userList = []

        this.tabActive = this.node.approverType + ''
        if (this.tabActive == '0') {
          this.selectVal = this.node.deptInfos

          if (!this.selectVal) {
            this.selectVal = []
          }

          this.defaultCheckedKeys = this.selectVal.map(e => e.id)
          this.$nextTick(() => {
            this.$refs['my_tree'].setCheckedKeys(this.defaultCheckedKeys)
          })
        }
        else if (this.tabActive == '1') {
          this.selectVal = this.node.approvers

          if (!this.selectVal) {
            this.selectVal = []
          }
          // this.userChecked = JSON.parse(JSON.stringify(this.oldData))
          this.userIdChecked = this.selectVal.map(e => e.id)
        }
        else if (this.tabActive == '2') {
          this.selectVal = this.node.tableCodeInfos

          if (!this.selectVal) {
            this.selectVal = []
          }
          // this.userChecked = JSON.parse(JSON.stringify(this.oldData))
          this.tableControlChecked = this.selectVal.map(e => e.key)
        }
      }


    },
  },
};
</script>

<style lang="scss" scoped>
.wf-select-user {
  width: 480px;
  height: calc(100% - 30px);
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border-radius: 10px 0px 0px 10px;
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px 10px 20px 20px;

  .tab-content {
    margin-top: 10px;
    height: calc(100% - 290px);
    padding-bottom: 15px;
  }
}
.headBox{
  display: flex;
  .el-radio{
    margin-top: 8px;
    margin-right: 20px;
  }
}
</style>